// extracted by mini-css-extract-plugin
export var date = "BlogEntryHero-module--date--a5655";
export var image = "BlogEntryHero-module--image--0afd8";
export var root = "BlogEntryHero-module--root--65be9";
export var social = "BlogEntryHero-module--social--f23ac";
export var titleWrapper = "BlogEntryHero-module--title-wrapper--1961e";
export var writtenBy = "BlogEntryHero-module--written-by--dad8c";